import { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom";
import { List, ListItem } from 'semantic-ui-react'
import { LoadingWrapper, ReactTable } from "../common";
import { fieldToNames } from "./Members"
import { fetchWithAuth, getCSRFToken } from "../auth";
import "../../css/members.css"
import "../../css/common.css";

const snakeToCamel = str =>
    str.toLowerCase().replace(/([-_][a-z])/g, group =>
        group
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
    );

export const MemberHistoryList = () => {
    const { id } = useParams()
    const [histories, setHistories] = useState([]);

    async function getHistoryList() {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + "members/" + id + "/history/", {
            headers: { 'X-CSRFToken': getCSRFToken() },
            credentials: 'include'
        })
        setHistories(await resp.json());
    }

    useEffect(() => {
        getHistoryList()
    }, [])

    const columnInfo = [
        {
            Header: "Changed By",
            accessor: "changedBy",
            Cell: (row) => {
                return <Link to={'/members/' + row.row.original.changedBy.id}>{row.row.original.changedBy.name}</Link>
            }
        },
        {
            Header: "Date",
            accessor: "changedOn",
            Cell: (row) => {
                return (new Date(row.row.original.changedOn)).toLocaleString()
            }
        },
        {
            Header: "Changes",
            accessor: (row) => {
                let stringChanges = ""
                for (const changeName of row.changes) {
                    stringChanges += changeName.field
                }
                return stringChanges
            },
            Cell: (row) => {
                return <Link to={"/members/" + id + "/changelog/" + row.row.original.id}><List>

                        {row.row.original.changes.map((change) => {
                            const normalizedField = snakeToCamel(change.field)
                            return <ListItem key={normalizedField} style={{ padding: "0.2rem" }}>
                                {fieldToNames[normalizedField] ? fieldToNames[normalizedField] : normalizedField}
                            </ListItem>
                        }
                        )}
                    </List></Link>
            }
        }
    ]

    return (
        <>
            <LoadingWrapper text="Loading member history" loading={false}>
                <div>
                    <ReactTable
                        className="channel-table"
                        data={histories}
                        columns={columnInfo}
                        editable={false}
                    />
                </div>
            </LoadingWrapper>
        </>
    )

}
